import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PreOrder from '../views/PreOrder.vue'
// import CreateAccount from '../views/CreateAccount.vue'
// import Simulator from '../views/Simulator.vue'
import NotFound from '../views/NotFound.vue'
import i18n from './../i18n'
import supportedLocales from './../../supported-locales'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    path: '/:lang',
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: 'commande',
        name: 'PreOrder',
        component: PreOrder
      },
      {
        path: 'commande/:modelId',
        name: 'PreOrderModel',
        component: PreOrder
      },
      {
        path: 'commande/:modelId/:versionId',
        name: 'PreOrderVersion',
        component: PreOrder
      },
      {
        path: 'commande/:modelId/:versionId/thankyou',
        name: 'ThankYou',
        component: PreOrder
      },
      // {
      //   path: 'inscription',
      //   name: 'CreateAccount',
      //   component: CreateAccount
      // },
      // {
      //   path: 'simulations',
      //   name: 'Simulator',
      //   component: Simulator
      // },
      {
        path: '*',
        name: 'NotFound',
        component: NotFound
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() { return { y: 0 }; },
  routes
})

router.beforeEach((to, from, next) => {
  let locale = 'fr'
  if (to.params.lang) {
    locale = to.params.lang
    if (!Object.keys(supportedLocales).includes(locale)) {
      locale = 'fr'
      next({path: `/${locale}${to.path}`})
      return
    }
    if (locale === from.params.lang) {
      next()
      return
    }
  }
  i18n.locale = locale
  document.documentElement.lang = locale
  document.dir = locale === 'ar' ? 'rtl' : 'ltr'
  // document.title = this.$t('app.title')
  next()
})

export default router
